import { Item } from './architecture.dto';
import { BasicResponseDTO } from './basicResponse.dto';
import { MenuItem } from './menuResponse.dto';

export class ItemStructure {
  class: string;
  hw_type?: string;
  subsystem: string;
  groups: ItemGroup[];
}

export class SavedItemStructure extends ItemStructure {
  groups: SavedItemGroup[];
}

export class ItemGroup {
  item_ids?: string[];
  regex?: string[];
  tags?: string[];
  exclude?: {
    regex?: string[];
    item_ids?: string[];
    tags?: string[];
  };
  parents?: {
    intersection: boolean;
    tags?: ParentTag[];
    item_ids?: string[];
    regex?: ParentRegex[];
  };
  withDeleted?: boolean;
}

export class ItemGroupExcludeWithLabels {
  items?: Item[];
  regex?: string[];
  tags?: {
    tag_id: string;
    tag: string;
  }[];
}

export class ItemGroupTag {
  tag_id: string;
  tag: string;
}

export class ItemGroupParentTag extends ItemGroupTag {
  subsystem: string;
}

export class ItemGroupParents {
  intersection: boolean;
  items?: Item[];
  regex?: ParentRegex[];
  tags?: ItemGroupParentTag[];
}

export class ItemGroupWithLabels {
  items?: Item[];
  regex?: string[];
  tags?: ItemGroupTag[];
  parents?: ItemGroupParents;
  exclude?: ItemGroupExcludeWithLabels;
  withDeleted?: boolean;
}

export class SavedItemGroup extends ItemGroup {
  item_group_id: string;
}

export class ParentTag {
  tag_id: string;
  subsystem: string;
}

export class ParentRegex {
  regex: string;
  subsystem: string;
}

export class CustomGroupItem {
  item_id: string;
  label: string;
  parents?: CustomGroupItemParent[];
}

export class CustomGroupItemParent {
  item_id: string;
  label: string;
}

export interface CustomGroupSearchResult {
  metadata: {
    start: number;
    end: number;
    max: number;
    page: number;
    info?: string;
  };
  items: CustomGroupItem[];
}

export class CustomGroupSearchDTO extends BasicResponseDTO {
  data: CustomGroupSearchResult;
}

export class CustomGroupItemDTO extends BasicResponseDTO {
  data: CustomGroupItem[];
}

export class CreateCustomGroupDTO extends ItemStructure {
  label: string;
  custom_group_folder_id: string;
  group_id?: number;
}

export class UpdateCustomGroupDTO extends SavedItemStructure {
  label: string;
  custom_group_id: string;
  custom_group_folder_id: string;
  group_id?: number;
}

// export class CreateCustomGroupDTO {
//   label: string = null;
//   hw_type: string = null;
//   subsystem: string = null;
//   item_ids: string[] = null;
//   regex: string[] = null;
//   parents?: string[] = null;
//   custom_group_folder_id: string = null;
// }

export class CustomGroupFolder {
  custom_group_folder_id?: string;
  label: string;
  parent?: string;
  path?: string;
}

export class CustomGroupFolderTree {
  custom_group_folder_id?: string;
  label: string;
  children?: CustomGroupFolderTree[];
}

export class CreateCustomGroupFolder {
  label: string;
  parent?: string;
  group_id?: number;
}

export class CustomGroup {
  custom_group_id?: string;
  class: string;
  label: string;
  hw_type: string;
  subsystem: string;
  groups: CustomGroupItemGroup[];
  custom_group_folder_id?: string;
  group_id?: number;
}

export class CustomGroupItemGroup {
  items?: Item[];
  regex?: string[];
  tags?: {
    tag_id: string;
    tag: string;
  }[];
  parents: {
    intersection: boolean;
    items?: Item[];
    regex?: ParentRegex[];
    tags?: {
      tag_id: string;
      tag: string;
      subsystem: string;
    }[];
  };
  exclude?: ItemGroupExcludeWithLabels;
}

export class GroupCustomGroupFolderTree {
  group_id: number;
  label: string;
  children: CustomGroupFolderTree[];
}

export class CustomGroupFoldersResponseDTO extends BasicResponseDTO {
  data: CustomGroupFolderTree[];
}

export class GroupCustomGroupFoldersTreeDTO extends BasicResponseDTO {
  data: GroupCustomGroupFolderTree[];
}

export class CustomGroupFolderResponseDTO extends BasicResponseDTO {
  data: CustomGroupFolder;
}

export class CustomGroupsResponseDTO extends BasicResponseDTO {
  data: CustomGroup[];
}

export class CustomGroupResponseDTO extends BasicResponseDTO {
  data: CustomGroup;
}

export class GroupCustomGroupFolder extends MenuItem {
  group_id: number;
}

export class GroupCustomGroupFoldersDTO extends BasicResponseDTO {
  data: GroupCustomGroupFolder[];
}

export class CustomGroupFavoriteResponseDTO extends BasicResponseDTO {
  data: {
    favorite: boolean;
  };
}
